import { Col, Container, Nav, NavItem, NavLink, Row } from "reactstrap";
import ProfileLayout from "../../../layouts/ProfileLayout";
import DefaultButton from "../../../components/Buttons/Default";
import "./styles.css";
import { useEffect, useState } from "react";
import ActiveTab from "./Tabs/Active";
import CompletedTab from "./Tabs/Completed";
import CancelledTab from "./Tabs/Cancelled";
import CreateWishRequestDrawer from "../../../components/Drawers/CreateWishRequest";
import { API_URL } from "../../../utils/constants";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

function WishRequestsPage() {
  const { t } = useTranslation('wishlist');
  const [activeTab, setActiveTab] = useState("active");
  const [activeWishRequests, setActiceWishRequests] = useState([]);
  const [completedWishRequests, setCompletedWishRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [addDrawerOpen, setAddDrawerOpen] = useState(false);

  const getWishRequests = () => {
    setLoading(true);

    fetch(API_URL+'/user/wish-requests', {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      }
    })
    .then(response => response.json())
    .then(data => {      
      if(data.success) {
        setActiceWishRequests(data.active_wish_requests);
        setCompletedWishRequests(data.completed_wish_requests);
      }
      setLoading(false);
    })
    .catch(error => {
      setLoading(false);
      toast.error('حدث خطأ أثناء اضافة الطلب');
    });
  }

  useEffect(() => {
    getWishRequests();
  }, []);

  return(
    <ProfileLayout>
      <Row>
        <Col md="10" className="mx-auto whih-requests-tabs">
          <Row className="mb-5 align-items-center">
            <Col xs="8">
              <h4 className="mb-0">{t("title")}</h4>
            </Col>
            <Col xs="4" className="text-end">
              <DefaultButton onClick={() => setAddDrawerOpen(true)}>
                +
                <span className="ms-1 d-lg-inline-block d-none">{t("add")}</span>
              </DefaultButton>
            </Col>
          </Row>

          <Nav fill className="mb-4">
            <NavItem>
              <NavLink
                active={activeTab === "active"}
                onClick={() => setActiveTab("active")}
              >
                { t("tabs.active") }
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                active={activeTab === "completed"}
                onClick={() => setActiveTab("completed")}
              >
                { t("tabs.completed") }
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                active={activeTab === "cancelled"}
                onClick={() => setActiveTab("cancelled")}
              >
                { t("tabs.cancelled") }
              </NavLink>
            </NavItem>
          </Nav>

          {activeTab === "active" && (
            <ActiveTab 
              requests={activeWishRequests} 
              refresh={getWishRequests}
            />
          )}
          {activeTab === "completed" && (
            <CompletedTab 
              requests={completedWishRequests} 
              refresh={getWishRequests}
            />
          )}
          {activeTab === "cancelled" && (
            <CancelledTab />
          )}
        </Col>
      </Row>

      <CreateWishRequestDrawer 
        isOpen={addDrawerOpen} 
        onSuccess={getWishRequests}
        toggle={() => setAddDrawerOpen(!addDrawerOpen)} 
      />
    </ProfileLayout>
  );
}

export default WishRequestsPage;